/*|---------------------------------------------------------
  | This file contains all original code by irfan
  | Needs a refactor, cache variables, lose jquery,
  | remove explicit event handlers bound to elements
  | but use named functions inside of a global helper
  | object instead
  |--------------------------------------------------------- */

import 'slick-carousel'

$.fn.visible = function(partial) {

    var $t            = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

};



$(document).ready(function () {

    var version = detectIE();
    if(version === 10){
        $(".weiwei_detail_section").addClass("ie-10");
    }

    function detectIE() {
        var ua = window.navigator.userAgent;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        // other browser
        return false;
    }


    /* =====================
     * This is for the filter in the city stories page. Possibly used on more places
     * ==================== */
    $(".mobile-filter__open").click(function () {
        this.closest('.filter-container').classList.add("mobile-filter-hide");
        document.getElementById("footer").classList.add("hidden");
    });

    $(".mobile-filter__close").click(function () {
        this.closest('.filter-container').classList.remove("mobile-filter-hide");
        document.getElementById("footer").classList.remove("hidden");
    });

    /* =====================
     * This is for the Routes map
     * ==================== */
    $(".mobile-route-filter__open").click(function () {
        document.getElementById("footer").classList.add("hidden");
    });

    $(".mobile-route-filter__close").click(function () {
        this.closest('.filter-section-container').classList.remove("visible");
        document.getElementById("footer").classList.remove("hidden");
    });


    $('.post__content-thumbnail:not(.post__content-thumbnail--no-slider), .slider__section').not('slick-initialized').slick({
        arrows: true,
        dots: true,
    });
    $('.top__slider').not('slick-initialized').slick({
        arrows: false,
        fade: true,
        dots: true,
        speed:4000,
        autoplay:true,
        autoplaySpeed:3000
    });

    $('.filter__btn a').on('click', function () {
        // $('.filter-section').toggleClass('visible');
    });

    var $window = $(window),
        $card2 = $('.agenda__section-posts, .home__posts, .insta__section-thumbnails, .home-activities-bar'),
        $partners = $('.partners__logo'),
        toggleSlick;

    toggleSlick = function () {
        $card2.not('.slick-initialized').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            adaptiveHeight: true,
            infinite: false,
            centerPadding: '20px',
            centerMode: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        });

        $partners.not('.slick-initialized').slick({
            autoplay: true,
            autoplaySpeed: 1,
            speed: 3000,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            adaptiveHeight: true,
            variableWidth:true,
            infinite: true,
            cssEase: 'linear',
            centerPadding: '0px',
            centerMode: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                }
            ]
        });
    };

    toggleSlick();

    $window.resize(toggleSlick); // TODO: throttle this terrible code


    /* =====================
     * Home page fade in animation
     * ==================== */
    var allMods = $(".animJs");
    var win = $(window);

    // Already visible modules
    allMods.each(function(i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass('slideUp');
        }
    });

    // TODO: Throttle this
    win.on('scroll load',function(event) {

        allMods.each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass('slideUp');
            }
        });

    });
});

/* =====================
 * This is for the menu
 * ==================== */

document.addEventListener('DOMContentLoaded', function(){

    let menuOpen = false;
    let submenuOpen = false;
    const submenuGradient = $('.submenu-gradient');
    const submenuBg = $('.submenu-bg');
    const documentBody = document.body;
    const htmlNode = document.querySelector('html');
    const newsletterWidget = $('.newsletter-action');
    const hamburgerButton = $('.menu--btn');
    const menuWrapperContent = document.querySelector('.menu__wrapper-content');
    const headersWithSubmenu = $('.has-submenu');

    // Event bindings
    hamburgerButton.on('click', toggleMenu);
    headersWithSubmenu.on('click', openSubmenu);

    $(document).keyup(e => {
        if (e.keyCode == 27) closeMenu();
    });

    $(".submenu__arrow-back").on("click", function() {
        closeSubmenu();
    });

    function toggleMenu() {
        if(! menuOpen) {
            openMenu();
            return;
        }
        closeMenu();
    }

    function closeMenu() {
        if (submenuOpen)
            closeSubmenu();

        menuOpen = false;
        htmlNode.classList.remove("slide__in");
        documentBody.classList.remove('overflow-hidden');
        submenuBg.removeClass('submenu-bg--visible');
        submenuGradient.removeClass('submenu-gradient--visible');
        newsletterWidget.removeClass('hidden');

        $('.wpb__nav .logo-container').removeClass('hidden');
        $('.wpb__nav .date').removeClass('hidden');
        $('.wpb__nav .nav--lang').removeClass('hidden');
        $('.wpb__nav').removeClass('hide-border-after');
    }

    function openMenu() {
        menuOpen = true;
        submenuBg.addClass('submenu-bg--visible');
        submenuGradient.addClass('submenu-gradient--visible');
        documentBody.classList.add('overflow-hidden');
        htmlNode.classList.add("slide__in");
        newsletterWidget.addClass('hidden');

        $('.wpb__nav .logo-container').addClass('hidden');
        $('.wpb__nav .date').addClass('hidden');
        $('.wpb__nav .nav--lang').addClass('hidden');
        $('.wpb__nav').addClass('hide-border-after');
    }

    function openSubmenu(event) {
        submenuOpen = true;
        if (window.innerWidth > 768) return;

        const submenuId = event.target.getAttribute('data-target');
        const submenu = document.getElementById(submenuId);
        menuWrapperContent.classList.add("menu__wrapper-content--moved-aside");
        submenu.classList.add("submenu--faded-in");
        let burger = document.querySelector(".nav--hamburger");
        burger.classList.add('hidden');
    }

    function closeSubmenu() {
        submenuOpen = false;
        menuWrapperContent.classList.remove("menu__wrapper-content--moved-aside");
        const submenu = document.querySelector(".submenu--faded-in");
        submenu.classList.remove("submenu--faded-in");
        let burger = document.querySelector(".nav--hamburger");
        burger.classList.remove('hidden');
    }

});

/* =====================
 * END Menu
 * ==================== */

window.createYoutubeEmbed = function (el, video) {

    const embed = "https://www.youtube-nocookie.com/embed/" + video + "?rel=0&amp;showinfo=0&autoplay=1";
    let iframe = document.createElement("iframe");
    let container = document.createElement('div');


    iframe.setAttribute("src", embed);
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allow", "autoplay; encrypted-media");
    iframe.setAttribute("allowfullscreen", "1");
    iframe.setAttribute("width", "100%");

    container.classList.add('youtube-embed');
    container.appendChild(iframe);

    el.parentNode.replaceChild(container, el);
}


$("#read-more_btn").click(function () {
    this.classList.add('hidden');
    document.getElementById("hidden-content").classList.remove("hidden");
    document.getElementById("read-less_btn").classList.remove("hidden");
});

$("#read-less_btn").click(function () {
    this.classList.add('hidden');
    document.getElementById("hidden-content").classList.add("hidden");
    document.getElementById("read-more_btn").classList.remove("hidden");
});

// Polyfill for IE causing the video in home to crash
(function () {
    if ( typeof window.CustomEvent === "function" ) return false; //If not IE

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

window.Event = CustomEvent;



// WEBPACK FOOTER //
// ./resources/assets/js/site/_bootstrap.js